import React, { useEffect, useState } from "react";
import PageContainer from "../../layouts/PageContainer";
import icon from "../../assets/images/avatar-icon.png";
import Button from "@material-ui/core/Button";
import { useHistory, useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
import { helpers } from "../../helper/helper";
import Swal from "sweetalert2";
import { Grid, TextField } from "@material-ui/core";
import PaginationInfo from "./PaginationInfo";
import PaginationControls from "./PaginationControls";
import moment from "moment";

const Shorts = ({ data, count, filterText, FetchRemainingApprovalList }) => {
  const [loading, setLoading] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const [totalCounts, setTotalCounts] = React.useState(null);
  const [limit, setLimit] = React.useState(12);
  const [page, setPage] = React.useState(1);
  const [list, setList] = React.useState([]);
  const history = useHistory();
  const location = useLocation();
  const [tag, setTag] = React.useState(location.state?.tag || "");
  const [category, setCategory] = React.useState(location.state?.category || "");

  useEffect(() => {
    setList(data);
    setTotalCounts(count);
  }, [data, count]);

  useEffect(() => {
    setPage(1);
  }, [filterText]);

  const handlePageChange = async (newPage) => {
    setPage(newPage);
    setLoading(true);
    await FetchRemainingApprovalList(filterText, search, newPage, limit);
    setLoading(false);
  };

  const handleSearch = async () => {
    setPage(1);
    setLoading(true);
    await FetchRemainingApprovalList(filterText, search, 1, limit);
    setLoading(false);
  };

  const handleAcceptPost = (id) => {
    Swal.fire({
      title: "Approve Post?",
      text: "Are you sure you want to approve this short?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve",
    }).then(async (result) => {
      console.log('result', result)
      if (result.value) {
        try {
          const url = `users/admin/pending/approve/update/${id}/v1`;

          const response = await helpers.apiCall("PUT", url, {
            type: filterText,
            status: "approved",
            reason: ""
          });

          if (response.status === 200) {
            Swal.fire("Approved!", "Post approved successfully.", "success");
            handleSearch(); // refresh list
          }
        } catch (error) {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    });
  };

  const handleRejectPost = (id) => {
    Swal.fire({
      title: "Reject Post",
      input: "textarea",
      inputLabel: "Reason for rejection",
      inputPlaceholder: "Enter rejection reason...",
      inputAttributes: {
        "aria-label": "Type your reason here",
      },
      showCancelButton: true,
      confirmButtonText: "Reject",
      confirmButtonColor: "#d33",
      preConfirm: (reason) => {
        if (!reason) {
          Swal.showValidationMessage("Reason is required");
        }
        return reason;
      },
    }).then(async (result) => {
      console.log('result', result)
      if (result.value) {
        try {
          const url = `users/admin/pending/approve/update/${id}/v1`;

          const response = await helpers.apiCall("PUT", url, {
            reason: result.value,
            type: filterText,
            status: "rejected",
          });

          if (response.status === 200) {
            Swal.fire("Rejected!", "Post rejected successfully.", "success");
            handleSearch();
          }
        } catch (error) {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    });
  };

  return (
    <>
      <PageContainer pageheading="Shorts"></PageContainer>
      <div className="row">
        <div className="col-12">
          <div className="row m-3">
            <div className="col-6">
            </div>
            <div className="col-6">
              
            </div>
            <div className="col-6">
              <Grid item xs={12} sm={12} md={12}>
                <div className="">
                  <div className="input-group serch-sec">
                    <TextField
                      size="small"
                      variant="outlined"
                      type="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="form-control rounded"
                      placeholder="Search Short Title, Created By user name and user Id"
                      aria-label="Search"
                      aria-describedby="search-addon"
                    />
                    &nbsp;
                    <Button
                      style={{ height: "38px" }}
                      variant="contained"
                      color="primary"
                      onClick={handleSearch}
                    >
                      Go
                    </Button>
                  </div>
                </div>
              </Grid>
            </div>
            <div className="col-6">
              <div className="row">
                <div className="col-md-6 d-flex">
                  {/* <p className="my-auto" style={{ fontWeight: "500" }}>1 to 10 of {totalCounts} items</p> */}
                  <PaginationInfo page={page} limit={limit} totalCounts={totalCounts} />
                </div>
                <PaginationControls limit={limit} onPageChange={handlePageChange} page={page} totalCounts={totalCounts} />
              </div>
            </div>
          </div>
          {
            loading ?
              <div style={{ display: "flex", width: "100%", height: "60vh", justifyContent: "center", alignItems: "center" }}>
                <div className="spinner-border" style={{ color: "#F85476" }} role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
              :
              <>
                <div className="row m-3">
                  {
                    list && list?.length > 0 ?
                      <>
                        {
                          list?.map(short => (
                            <React.Fragment key={short?._id}>
                              <div className="col-md-6 col-sm-12 mt-3">
                                <div className="post_card">
                                  <div className="post_card_header">
                                    <div>
                                      <img src={short?.createdBy?.profilePic ? short.createdBy.profilePic : icon} alt="" style={{ cursor: "pointer" }} onClick={e => history.push(`/dashboard/users/${short?.createdBy?._id}`)} />
                                      <span className="ml-3">{short?.createdBy?.name}</span>
                                      {short?.createdAt && (
                                        <p style={{ fontSize: "12px", color: "#888" }}>
                                          {moment(short.createdAt).format("MMM DD, YYYY [at] hh:mm A")}
                                        </p>
                                      )}
                                    </div>
                                    <div>
                                      <>
                                        <Button
                                          variant="contained"
                                          style={{ backgroundColor: "#4CAF50", color: "#fff" }}
                                          className="mb-2 mr-1"
                                          onClick={(e) => handleAcceptPost(short?._id)}
                                        >
                                          Accept
                                        </Button>
                                        <Button
                                          variant="contained"
                                          style={{ backgroundColor: "#f44336", color: "#fff" }}
                                          className="mb-2"
                                          onClick={(e) => handleRejectPost(short?._id)}
                                        >
                                          Reject
                                        </Button>
                                      </>
                                    </div>
                                  </div>
                                  <div className="post_card_content">
                                    <div className="post_media">
                                      <p>{short?.title}</p>
                                      <span style={{ display: "block" }}><span
                                        style={{ fontSize: "18px" }}
                                        className="mdi mdi-bookmark-music"
                                      ></span> {short?.songDetails?.name} {short?.isOriginal && <span
                                        style={{ fontSize: "18px" }}
                                        className="mdi mdi-check-circle"
                                      ></span>}</span>
                                      <span style={{ display: "block", cursor: "pointer" }} onClick={e => setCategory(short?.category)}>category - {short?.reelCategory?.name}</span>
                                      <video controls style={{ maxHeight: "280px", width: "auto", maxWidth: "100%", height: "auto", display: "block", margin: 0 }}>
                                        <source src={short?.url} />
                                      </video>
                                    </div>
                                    {/* <div className="post_hashtags">
                                      {
                                        short?.tags && short?.tags?.length > 0 && short?.tags?.map(tag => (
                                          <span style={{ cursor: "pointer" }} onClick={e => setTag(tag)}>#{tag}</span>
                                        ))
                                      }
                                    </div> */}
                                    <div className="d-flex interaction-action">
                                      <div className="d-flex flex-column align-items-center">
                                        <span>{short?.views?.length}</span>
                                        <span
                                          style={{ fontSize: "28px" }}
                                          className="mdi mdi-arrow-right-drop-circle-outline"
                                        ></span>
                                        {/* <span>Views</span> */}
                                      </div>
                                      <div className="d-flex flex-column align-items-center">
                                        <span>{short?.totalZems || 0}</span>
                                        <span
                                          style={{ fontSize: "28px" }}
                                          className="mdi mdi-diamond-outline"
                                        ></span>
                                        {/* <span>Views</span> */}
                                      </div>
                                      <div
                                        style={{ cursor: "pointer" }}
                                        className="d-flex flex-column align-items-center"
                                      >
                                        <span>{short?.like?.length}</span>
                                        <span
                                          style={{ fontSize: "28px" }}
                                          className="mdi mdi-thumb-up-outline"
                                        ></span>
                                        {/* <span>Like</span> */}
                                      </div>
                                      <div
                                        style={{ cursor: "pointer" }}
                                        className="d-flex flex-column align-items-center"
                                      >
                                        <span>{short?.disLike?.length}</span>
                                        <span
                                          style={{ fontSize: "28px" }}
                                          className="mdi mdi-thumb-down-outline"
                                        ></span>
                                        {/* <span>Like</span> */}
                                      </div>
                                      <div
                                        style={{ cursor: "pointer" }}
                                        className="d-flex flex-column align-items-center"
                                      >
                                        <span>{short?.reelComments?.length}</span>
                                        <span
                                          style={{ fontSize: "28px" }}
                                          className="mdi mdi-comment-text-outline"
                                        ></span>
                                      </div>
                                      <div className="d-flex flex-column align-items-center">
                                        <span>{short?.share || 0}</span>
                                        <span
                                          style={{ fontSize: "28px" }}
                                          className="mdi mdi-share-outline"
                                        ></span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </React.Fragment>
                          ))
                        }
                      </>
                      :
                      <>
                        <h2 className="text-center mt-3">Not Found</h2>
                      </>
                  }
                </div>
              </>
          }
        </div>
      </div>
      {/* <SelectTopReelModel getListOfShort={getListOfShort} reelId={reelId} isSelectedReel={isSelectedReel} handleCloseModal={handleCloseModal} handleDelete={confirmDeleteModal} setReelTopMadal={setReelTopMadal} modal={reelTopMadal} reason={reason} setReason={setReason} />
      <LikeModal likeModal={likeModal} handleCloseLikeModal={handleCloseLikeModal} data={selectedShortLikeData} />
      <DisLikeModal disLikeModal={disLikeModal} handleCloseDisLikeModal={handleCloseDisLikeModal} data={selectedShortDisLikeData} />
      <CommentModal commentModal={commentModal} handleCloseCommentModal={handleCloseCommentModal} data={selectedShortCommentData} />
      <DeleteReson handleCloseModal={handleCloseModal} handleDelete={confirmDeleteModal} modal={modal} reason={reason} setReason={setReason} />
      <HideReson handleCloseModal={handleCloseHideModal} handleHide={confirmHideModal} modal={hideModal} reason={hideReason} setReason={setHideReason} /> */}
    </>
  );
};

export default Shorts;
